import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=154a567a&"
import script from "./EmailValidation.vue?vue&type=script&lang=js&"
export * from "./EmailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports